import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_drop",
  "use": "icon-arrow_drop-usage",
  "viewBox": "0 0 21 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 11\" id=\"icon-arrow_drop\"><path d=\"M11.356.2l8.985 8.987a1.012 1.012 0 0 1 0 1.429 1.007 1.007 0 0 1-1.426 0l-8.272-8.274-8.271 8.273a1.008 1.008 0 0 1-1.427 0 1.012 1.012 0 0 1 0-1.429L9.93.2a1.018 1.018 0 0 1 1.426 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol